/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import * as Yup from 'yup'
import {Link, useNavigate} from 'react-router-dom'

import clsx from 'clsx'
import {useFormik} from 'formik'
import {useSelector, useDispatch} from 'react-redux'
import {getSignUpData, fetchAsyncSignUp, clearSignUpData} from '../../../../Redux/FrontEnd'
import RegistartionOtpModal from './RegistartionOtpModal'
import {fetchAsyncVerifyOtp} from './UserLoginRedux/UserLoginSlice'
import {reset} from '../../../../Redux/store'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'

const registrationSchema = Yup.object().shape({
  name: Yup.string()
    .required('First name is required')
    .max(25, 'Must be less than 25 characters')
    .trim('The contact name cannot include leading and trailing spaces'),
  email: Yup.string().email('Wrong email format').required('Email is required'),
  password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
      'Minimum eight characters, at least one uppercase & lowercase letter, one number and one special character'
    )
    .max(50, 'Must be less than 50 characters')
    .required('Password is required'),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Confirm password is required'),
  companyName: Yup.string()
    .max(25, 'Must be less than 25 characters')
    .required('Company name is required')
    .trim('The contact name cannot include leading and trailing spaces'),
  mobile: Yup.string()
    .matches(
      /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
      'Please enter valid number'
    )
    .required('Mobile number is required'),
})

export function Registration() {
  const initialValues = {
    name: '',
    email: '',
    companyName: '',
    password: '',
    passwordConfirmation: '',
    mobile: '',
    isoCode: '',
  }

  const [loading, setLoading] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState<any>()

  const signUpData = useSelector(getSignUpData)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [OTP, setOTP] = useState<any>()
  const [otpVisible, setOtpVisible] = useState(false)
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setPhoneNumber(values?.mobile)
      try {
        let data = {
          name: values.name,
          email: values.email,
          password: values.password,
          company: values.companyName,
          mobile: values.mobile,
          isocode: 'au',
        }
        dispatch(fetchAsyncSignUp(data)).then((res: any) => {
          !res?.error && setOtpVisible(true)
        })

        // dispatch(fetchAsyncResendMobileOtp({mobile: values.phoneNumber}))
        setLoading(false)
      } catch (error) {
        console.error(error)
        setStatus('The login detail is incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })
  const handleEnter: any = (event: any) => {
    // event.preventDefault()
    const data = {
      otp: OTP,
      mobile: phoneNumber,
      type: 'SIGNUP_MOBILE',
    }
    dispatch(fetchAsyncVerifyOtp(data)).then((res: any) => {
      !res.error && dispatch(reset()) && setOtpVisible(false)

      navigate('/')
    })
    // dispatch(logout())
    // setOTP('')
  }

  useEffect(() => {
    if (signUpData.data?.email) {
      setOtpVisible(true)
      dispatch(clearSignUpData())
    }
  }, [signUpData.data?.email])

  return (
    <div>
      {otpVisible && (
        <RegistartionOtpModal
          phoneNumber={phoneNumber}
          show={otpVisible}
          handleClose={() => setOtpVisible(false)}
          email={formik.values.email}
          stopLoading={setLoading}
          handleEnter={() => handleEnter()}
          setOTP={setOTP}
          OTP={OTP}
        />
      )}
      <form className='form w-100 px-10' noValidate onSubmit={formik.handleSubmit}>
        <div className='card-body text-start mb-10 mw-100'>
          <h1 className='text-dark mb-3 text-center' data-kt-translate='sign-up-title'>
            Create an Account
          </h1>

          <div className='d-flex flex-stack justify-content-center py-2'>
            <span className='text-gray-400 fw-bold fs-5 me-2' data-kt-translate='sign-up-head-desc'>
              Already a member ?
            </span>
            <Link to='/auth/login'>
              <a className='link-primary fw-bold fs-5' data-kt-translate='sign-up-head-link'>
                Sign In
              </a>
            </Link>
          </div>

          <div className='sign-google mt-5'>
            <a href='#' className='symbol symbol-circle symbol-45px me-3'>
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
                className=''
              />
              Sign in with Google
            </a>
          </div>

          <div
            className='text-gray-400 fs-6 mb-5 text-center me-md-6'
            data-kt-translate='general-or'
          >
            OR
          </div>

          <div className='row'>
            {/* //first Name */}
            <div className='fv-row col-md-6 mb-6'>
              <label className='form-label fs-6 fw-bolder text-dark'>Full Name</label>
              <input
                placeholder='Full Name'
                {...formik.getFieldProps('name')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik.touched.name && formik.errors.name},
                  {
                    'is-valid': formik.touched.name && !formik.errors.name,
                  }
                )}
                type='text'
                name='name'
                autoComplete='off'
              />
              {formik.touched.name && formik.errors.name && (
                <div className='fv-plugins-message-container'>
                  <span role='alert' className='text-danger'>
                    {formik.errors.name}
                  </span>
                </div>
              )}
            </div>
            {/* //email */}
            <div className='fv-row col-md-6 mb-6'>
              <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
              <input
                placeholder='Email'
                {...formik.getFieldProps('email')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik.touched.email && formik.errors.email},
                  {
                    'is-valid': formik.touched.email && !formik.errors.email,
                  }
                )}
                type='email'
                name='email'
                autoComplete='off'
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <span role='alert' className='text-danger'>
                    {formik.errors.email}
                  </span>
                </div>
              )}
            </div>
            {/* company */}
            <div className='fv-row col-md-6 mb-6'>
              <label className='form-label fs-6 fw-bolder text-dark'>Company</label>
              <input
                placeholder='Company'
                {...formik.getFieldProps('companyName')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik.touched.companyName && formik.errors.companyName},
                  {
                    'is-valid': formik.touched.companyName && !formik.errors.companyName,
                  }
                )}
                type='text'
                name='companyName'
                autoComplete='off'
              />
              {formik.touched.companyName && formik.errors.companyName && (
                <div className='fv-plugins-message-container'>
                  <span role='alert' className='text-danger'>
                    {formik.errors.companyName}
                  </span>
                </div>
              )}
            </div>
            {/* phone Number */}
            <div className='fv-row col-md-6 mb-6'>
              <label className='form-label fs-6 fw-bolder text-dark'>Phone Number</label>
              <input
                placeholder='Phone Number'
                {...formik.getFieldProps('mobile')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik.touched.mobile && formik.errors.mobile},
                  {
                    'is-valid': formik.touched.mobile && !formik.errors.mobile,
                  }
                )}
                type='text'
                name='mobile'
                autoComplete='off'
              />
              {formik.touched.mobile && formik.errors.mobile && (
                <div className='fv-plugins-message-container'>
                  <span role='alert' className='text-danger'>
                    {formik.errors.mobile}
                  </span>
                </div>
              )}
            </div>
            {/* password */}
            <div className='fv-row col-md-6 mb-6'>
              <div className='d-flex justify-content-between'>
                <div className='d-flex flex-stack mb-2'>
                  <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>

                  {/* end::Link */}
                </div>
              </div>
              <input
                type='password'
                placeholder='Password'
                autoComplete='off'
                {...formik.getFieldProps('password')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {
                    'is-invalid': formik.touched.password && formik.errors.password,
                  },
                  {
                    'is-valid': formik.touched.password && !formik.errors.password,
                  }
                )}
              />
              {formik.touched.password && formik.errors.password && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert' className='text-danger'>
                      {formik.errors.password}
                    </span>
                  </div>
                </div>
              )}
              <div className='text-muted mt-2'>
                Use 8 or more characters with a mix of letters, numbers & symbols.
              </div>
            </div>
            <div className='fv-row col-md-6 mb-6'>
              <div className='d-flex justify-content-between'>
                <div className='d-flex flex-stack mb-2'>
                  <label className='form-label fw-bolder text-dark fs-6 mb-0'>
                    Confirm password
                  </label>

                  {/* end::Link */}
                </div>
              </div>
              <input
                type='text'
                placeholder='Confirm Password'
                autoComplete='off'
                {...formik.getFieldProps('passwordConfirmation')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {
                    'is-invalid':
                      formik.touched.passwordConfirmation && formik.errors.passwordConfirmation,
                  },
                  {
                    'is-valid':
                      formik.touched.passwordConfirmation && !formik.errors.passwordConfirmation,
                  }
                )}
              />
              {formik.touched.passwordConfirmation && formik.errors.passwordConfirmation && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert' className='text-danger'>
                      {formik.errors.passwordConfirmation}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className='d-flex flex-stack'>
              <button
                type='submit'
                id='kt_sign_up_submit'
                className='btn  me-2 flex-shrink-0 auth-primary-btn'
                disabled={formik.isSubmitting}
              >
                {!loading && (
                  <span className='indicator-label text-white' data-kt-translate='sign-in-submit'>
                    Sign Up
                  </span>
                )}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}
